import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { XCircle } from 'lucide-react';

export function CheckoutCancel() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect after a short delay
    const timer = setTimeout(() => {
      navigate('/');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <XCircle className="w-16 h-16 text-red-500 mx-auto" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Payment Cancelled
        </h1>
        <p className="text-gray-600 dark:text-gray-300">
          Your payment was cancelled. You'll be redirected back to the app in a moment.
        </p>
      </div>
    </div>
  );
}